import React, { useEffect, useState } from 'react';
import styles from 'styles/Chat.module.scss';
import { Button, Label } from 'reactstrap';
import { File, PlusCircle, XCircle } from 'react-feather';
import classNames from 'classnames';
import { showToastError } from '../../../../@core/components/toastify/ToastTypes';
import { acceptTypeImages, allowTypeDocuments } from './InputChat';

const FileReview = (props) => {
  const { file, handleRemoveFile, index, isBusy } = props;
  const [src, setSrc] = useState('');
  useEffect(() => {
    if (file?.type?.indexOf('image/') !== -1) {
      const reader = new FileReader();
      reader.onload = function (e) {
        setSrc(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  }, [file]);

  const renderFile = () => {
    if (file?.type?.indexOf('image/') !== -1) {
      return <img src={src} className={styles['image-review']} />;
    }
    return (
      <div className={styles['file-review']}>
        <File size={20} className="ml-25" />
        <span
          className={classNames(styles['file-review__name'], 'font-small-3')}
        >
          {file?.name}
        </span>
      </div>
    );
  };

  return (
    <div
      className={classNames(
        styles['wrap-file-review'],
        file?.type?.indexOf('image/') === -1
          ? styles['wrap-file-review__document']
          : '',
      )}
    >
      {renderFile()}
      <Button
        className={`btn-icon round ${styles['image-review__close']}`}
        color="flat-secondary"
        disabled={isBusy}
        onClick={() => handleRemoveFile(index)}
      >
        <XCircle size={16} />
      </Button>
    </div>
  );
};

const UploadFileDetail = (props) => {
  const { files, setFiles, isBusy, typeFile } = props;
  if (!files?.length) {
    return null;
  }

  function handleRemoveFile(index) {
    const newFiles = [...files];
    newFiles?.splice(index, 1);
    setFiles(newFiles);
  }

  function onAddMore(e) {
    if (e.target.files?.length) {
      const acceptTypes =
        typeFile === 'image' ? acceptTypeImages : allowTypeDocuments;
      const index = Object.values(e.target.files).findIndex(
        (item) => item?.size / (1024 * 1024) > 25,
      );
      const acceptFiles = Object.values(e.target.files)?.filter(
        (item) =>
          item?.type &&
          acceptTypes.indexOf(item?.type) !== -1 &&
          item?.size / (1024 * 1024) <= 25,
      );
      if (index !== -1) {
        showToastError(
          'File size exceeds the limit. Maximum allowed size is 25MB.',
        );
        return;
      }
      if (!acceptFiles?.length) {
        showToastError('No image available!');
        return;
      }
      if ([...files, ...acceptFiles]?.length > 15) {
        showToastError(
          'Exceeded the maximum file count. The limit is 15 files.',
        );
        return;
      }
      setFiles([...files, ...acceptFiles]);
    }
  }

  return (
    <div className={styles['wrap-files-detail']}>
      <div className="flexRow justify-content-end">
        <Button
          className={`btn-icon round ${styles['image-review__close']}`}
          color="flat-secondary"
          onClick={() => setFiles(undefined)}
          disabled={isBusy}
        >
          <XCircle size={16} />
        </Button>
      </div>
      <div className="full-width">
        <div className="flexRow">
          {files?.map((item, index) => (
            <FileReview
              isBusy={isBusy}
              file={item}
              key={index}
              index={index}
              handleRemoveFile={handleRemoveFile}
            />
          ))}
          <div className="flexRow align-items-center">
            <Button.Ripple
              className="btn-icon px-0 py-0"
              outline
              color="secondary"
              disabled={isBusy}
            >
              <Label
                for="attach-doc-more"
                className={classNames('align-middle mx-05 my-05', {
                  'cursor-pointer': !isBusy,
                })}
              >
                <PlusCircle size={16} />
              </Label>
              {!isBusy && (
                <input
                  type="file"
                  id="attach-doc-more"
                  hidden
                  multiple
                  accept={
                    typeFile === 'image' ? acceptTypeImages : allowTypeDocuments
                  }
                  onChange={onAddMore}
                  onClick={(event) => {
                    event.target.value = null;
                  }}
                />
              )}
            </Button.Ripple>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadFileDetail;
